export interface SearchItemsSection {
  list: string;
  items: { title?: unknown; link?: string; searchTerms?: unknown[] }[];
}

export interface UnsearchableItem {
  list: string;
  link: string;
  field: 'title' | 'searchTerms';
  type: string;
}

/**
 * Global search lowercases every item's title and search terms, so a single
 * item whose title isn't a string throws on every keystroke and the results
 * stop filtering (Sentry CLIENT-APP-5W0, CLIENT-APP-5VY). Lists those items by
 * section and link, so a report shows which source produced them.
 */
export function findUnsearchableItems(sections: SearchItemsSection[] | null | undefined): UnsearchableItem[] {
  const found: UnsearchableItem[] = [];
  for (const section of sections || []) {
    for (const item of section.items || []) {
      const link = item.link ?? '';
      if (typeof item.title !== 'string') {
        found.push({ list: section.list, link, field: 'title', type: typeName(item.title) });
      }
      const badTerms = (item.searchTerms || []).filter((term) => typeof term !== 'string');
      if (badTerms.length) {
        found.push({ list: section.list, link, field: 'searchTerms', type: typeName(badTerms[0]) });
      }
    }
  }
  return found;
}

function typeName(value: unknown): string {
  return value === null ? 'null' : typeof value;
}
